import { useEffect, useCallback } from 'react'
import { useWebSocket } from './WebSocketProvider'
import { DEPLOYMENT_EVENTS } from './constants'

const useDeploymentEvents = (options = {}) => {
  const { subscribe } = useWebSocket()

  const {
    onCreated,
    onUpdated,
    projectId,
    deployableId,
  } = options

  const matchesFilter = useCallback((deployment) => {
    if (projectId && deployment.deployableId !== projectId) return false
    if (deployableId && deployment.deployableId !== deployableId) return false
    return true
  }, [projectId, deployableId])

  const createHandler = useCallback((handler) => {
    if (!handler) return null
    return (deployment) => {
      if (matchesFilter(deployment)) {
        handler(deployment)
      }
    }
  }, [matchesFilter])

  useEffect(() => {
    const unsubscribers = []

    if (onCreated) {
      const handler = createHandler(onCreated)
      if (handler) {
        unsubscribers.push(subscribe(DEPLOYMENT_EVENTS.CREATED, handler))
      }
    }

    if (onUpdated) {
      const handler = createHandler(onUpdated)
      if (handler) {
        unsubscribers.push(subscribe(DEPLOYMENT_EVENTS.UPDATED, handler))
      }
    }

    return () => {
      unsubscribers.forEach((unsubscribe) => unsubscribe())
    }
  }, [subscribe, createHandler, onCreated, onUpdated])
}

export default useDeploymentEvents
